/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} State_RegistrationInputs */



/**
* | output |
* | --- |
* | "Registration" |
*
* @param {State_RegistrationInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const state_registration = /** @type {((inputs?: State_RegistrationInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<State_RegistrationInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Inscription")
	if (locale === "es") return /** @type {LocalizedString} */ ("Inscripción")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Inscrição")
	if (locale === "it") return /** @type {LocalizedString} */ ("Iscrizione")
	return /** @type {LocalizedString} */ ("Registration")
});